import TextField from "../Reusable/TextInput";

import APIS from "../../constant/Endpoint";
import LocalComboboxInput from "../Reusable/LocalComboboxInput";
import MultipleSelectField from "../Reusable/MultipleSelectField";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import DateInput from "../Reusable/DateInput";
import { RichTextEditor } from "../Reusable/RichTextEditor";
const NoticeForm = (props: any) => {
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    setError,
    isPostLoading,
    handleCreate,
    errors,
    control,
    NoticeData = [],
    clearErrors,
  } = props;
  const TypeData = [
    {
      id: "popup",
      name: "popup",
    },
    {
      id: "alert",
      name: "alert",
    },
  ];
  return (
    <>
      <div className={tw`grid grid-cols-2 gap-x-4 px-4`}>
        <DateInput
          type="date"
          label={"Start Date"}
          register={register(`start_date` as const, {
            required: false,
          })}
          errors={errors?.start_date}
        />
        <DateInput
          type="date"
          label={"Expiry Date"}
          register={register(`expiry_date` as const, {
            required: false,
          })}
          errors={errors?.expiry_date}
        />
        <TextField
          label={"Title"}
          register={register("title")}
          errors={errors?.title}
        />
        <TextField
          label={"Theme"}
          register={register("theme")}
          errors={errors?.theme}
        />
        <LocalComboboxInput
          data={TypeData}
          register={register("type")}
          errors={errors?.type}
          name={"type"}
          label={"Type"}
          setValue={setValue}
          getValues={getValues}
          placeholder={"Search Type"}
          clearErrors={clearErrors}
        />
        <MultipleSelectField
          label={"Branch"}
          queryKey={"branch"}
          register={register("branch")}
          watch={watch}
          setValue={setValue}
          url={`${APIS.BRANCH}`}
          value={
            NoticeData?.branch
              ? NoticeData?.branch?.map((item: any, index: number) => ({
                  label: item?.name,
                  value: item?.id,
                }))
              : []
          }
        />
        <MultipleSelectField
          label={"User"}
          queryKey={"user"}
          register={register("user")}
          watch={watch}
          setValue={setValue}
          url={`${APIS.USER}`}
          value={
            NoticeData?.user
              ? NoticeData?.user?.map((item: any, index: number) => ({
                  label: item?.name,
                  value: item?.id,
                }))
              : []
          }
        />
        <MultipleSelectField
          label={"Staff"}
          queryKey={"staff"}
          register={register("staff")}
          watch={watch}
          setValue={setValue}
          url={`${APIS.STAFF}`}
          value={
            NoticeData?.staff
              ? NoticeData?.staff?.map((item: any, index: number) => ({
                  label: item?.full_name,
                  value: item?.id,
                }))
              : []
          }
        />
      </div>
      <div className={tw`px-4`}>
        <RichTextEditor
          name="content"
          control={control}
          setValue={setValue}
          errors={errors.content}
          label="Content"
        />
      </div>
      {/* <div className={tw`w-full mt-2 `}>
        <label>Content</label>
        <textarea
          rows={6}
          {...register("content")}
          className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
        />
        {errors?.content && (
          <p className={tw`text-red-500 text-xs my-1`}>
            {errors?.content?.message}
          </p>
        )}
      </div> */}
    </>
  );
};

export default NoticeForm;
